import { memoize } from "lodash-es";

import { IJobRequestDetailMatchProps, IJobRequestDetailRouteProps } from "./types";

const transformPropsBody = (props: IJobRequestDetailMatchProps) => {
  return { jobRequestId: parseInt(props.match.params.jobRequestId, 10) };
};
const transformPropsResolver = (props: IJobRequestDetailRouteProps) => {
  return props.location.pathname + props.location.search;
};

export const transformRouteProps = memoize(transformPropsBody, transformPropsResolver);
